import React, { useContext, useEffect, useRef, useState } from 'react'
import ComedyBreadCrumb from '../comedyBreadCrumb'
import  '../../../styles/videoDetails.css'
import { Link } from 'react-router-dom'
import SocialShare from '../socialShare'
import { useLocation } from 'react-router-dom'
import YoutubePlayer from '../youtubePlayer'
import { Helmet } from 'react-helmet-async'
import { DeviceContext } from '..'
import PageAds from '../../common/pageAds'



const ComedyVideoDetails = ({data}) => {

         
              // const [breadCrumb,setBreadCrumb] = useState({})
              const location = useLocation().pathname 
              const cut_location = location.substring(0,location.lastIndexOf('-'))
              const vgal_id = location.substring(location.lastIndexOf('-')+1,location.lastIndexOf('.html'))
              const vcategory_id = cut_location.substring(cut_location.lastIndexOf('-')+1)
              const {mobile,setMobile,containerRef} = useContext(DeviceContext)
              const ssrData =  data?.[0]?.vidDetailsPage || {}
              const ssrVidData = ssrData.vidData
              const ssrVgalId = data?.[0]?.vidDetailsPage?.ssrVgalId
              const [vidData,setVidData] = useState(ssrVidData)
               const [prev,setPrev] = useState(ssrData.previous)
                const [nxt,setNxt] = useState(ssrData.next)
              const [loading,setLoading] = useState(ssrData.vidData ? false : true)
              const [error,setError] = useState(null)
            const  vgalIdRef= useRef(ssrVgalId || vgal_id)
            const [adJson ,setAdJson] = useState(null)
   
            
             
      useEffect(() => {
        fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
         .then(res => res.json())
         .then(data => setAdJson(data))
         .catch(err => console.error(err));
       }, []);                     
                    


   useEffect(() => {
     
    

           if ( vgalIdRef.current !== vgal_id) {
                                    setVidData(null)         
                                   setPrev(null);
                                   setNxt(null);
                                  setLoading(true);        
                              }

            if (ssrVidData &&  vgalIdRef.current === vgal_id)  {
              vgalIdRef.current = vgal_id
              setLoading(false)
              return;

            }  
       
          const getData = async() => {
           
             setLoading(true)
             try {
                //  const res_one = VIDEOSLIST_CATEGORIES.map((item) => String(item.id) === String(vcategory_id) )
                  // const one = res_one ? res_one[0].id : ''
                let response = await fetch(`https://www.teluguone.com/comedy/comedyVideoSingleJson.php?vgal_id=${vgal_id}&vcat_id=${vcategory_id}`);
                if (!response.ok) throw new Error(`Server Response Was Not Ok`)
                let result  = await  response.json()
                // const two = result.comedy_video_single[0].title ? result.comedy_video_single[0].title : ''
                //  setBreadCrumb({one:one,two:two})
                setVidData(result.comedy_video_single[0])
                setPrev(result.comedy_video_single[1].previous_url ? result.comedy_video_single[1] : {}
                );
                setNxt( result.comedy_video_single[1].next_film ? result.comedy_video_single[1] : result.comedy_video_single[2] );
                setError(null)
              
             } catch (error) {
                setVidData(null)
                setError(error.message)
                console.log(`Error :`,error.message)
             } finally {
               setLoading(false)
                isFirst.current = false
             }  

            
           }

    setVidData(null)
        getData()

   },[vgal_id, location])

      function getCatName(cid) {
               let id = String(cid).includes(",") ? cid.substring(0,cid.indexOf(',')) : cid  
                  let catname = ''
                      if(Number(id) === 25) catname ="Erri Dippa" 
                      if(Number(id) === 26) catname ="Spoofs" 
                      if(Number(id) === 6)  catname ="Mallik Comedy" 
                      if(Number(id) === 5)  catname ="Shhh Gup Chip" 
                      if(Number(id) === 4)  catname ="Happy Happyga" 
                      if(Number(id) === 14) catname ="Telugu Comedy Videos" 
                      if(Number(id) === 31) catname ="Archives"   
                   return catname;
              }  




  return (
    <div className='container-fluid comedy-videodetails-page'>
        <div className='row'>
           <Helmet><title>{ vidData?.title || 'Telugu Comedy Video Display Page'} | Telugu Comedy Video</title></Helmet>
           <div className='col-12'>
               {/* <ComedyBreadCrumb breadCrumb={breadCrumb} /> */}
                <ComedyBreadCrumb breadCrumb={{one:`${vidData && getCatName(vcategory_id) || ''}`,two:`${vidData && vidData.title || ''}`} } />
           </div>

            {loading && <div className='col-12'> <div className="youtube-player text-center"><p>Loading......</p></div></div>}

            <div className='col-12'>
              
              { vidData && <YoutubePlayer playerClass={"youtube-player"} videoId={vidData.video_id ? vidData.video_id : ''} /> }


           
              
            </div>
            {vidData && <div className='col-12'><SocialShare /></div>}
           { vidData && <div className='col-12'><center> 
                     {adJson && adJson.googleNewsAd?.link ? <a href={adJson?.googleNewsAd?.link} target="_blank" rel="noreferrer">
                        <img src={adJson?.googleNewsAd?.img} alt="google-ad-img" />
                        </a>
                        :
                        <a href="https://news.google.com/search?q=site:teluguone.com&hl=te&gl=IN&ceid=IN:te" target="_blank" rel="noreferrer">
                              <img src=" https://www.teluguone.com/images/g-news-banner.gif" alt="google-ad-img" />
                        </a>
                        
                        } 
                   </center></div>}
           { vidData && <div className='col-12'>
                  <div className='prev-next-box d-flex justify-content-between'>
                     {prev && prev.previous_url ? <button type="button"><Link to={prev.previous_url.substring(prev.previous_url.lastIndexOf('/videodetails')).replace("?","-")} >{"«"} Previous</Link></button> : <p> </p>}
                     { nxt && nxt.next_film ?   <button type="button"><Link to={nxt.next_film.substring(nxt.next_film.lastIndexOf('/videodetails')).replace("?","-")} >Next {"»"}</Link></button> : <p> </p>}
                  </div>  
            </div>}

             {error && <div className='col-12'>
                          <div className="json-loading-error-div">
                            <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                          </div>
                      </div>
              }
          
        </div>  
        <PageAds  mobile={mobile} containerRef={containerRef} />         
    </div>
  )
}


export default ComedyVideoDetails;